import { api } from '@/shared/api/client';

/** Mirrors `com.qssi.ph10.features.auth.renew.dto.RenewResponse`. */
export interface RenewResponse {
  token: string;
  expiresAt: string;
  sessionExpiresAt: string;
  idleMinutes: number;
  warnSeconds: number;
  warnSound: boolean;
  kiosk: boolean;
}

/**
 * `POST /api/auth/renew` — PH10's twin of PB's Resume button
 * (`w_phfc_timer_countdown.srw:138-142`). slice-3560 (ADR-0046).
 *
 * <p>Body-less: everything the server needs is the bearer token and the session it points at,
 * and nothing the client could assert about its own idleness would be trustworthy anyway.
 *
 * <p>`keepSessionOn401: true` matters. The server refuses a renew with a 401 when the token is
 * expired, the session is dead, or the idle/absolute limit has passed — if that 401 went
 * through the generic handler it would clear the store from inside the very call whose failure
 * the caller is about to handle. The caller (`useSessionExpiry`) owns the decision.
 */
export function renewSession(): Promise<RenewResponse> {
  return api<RenewResponse>('/api/auth/renew', { method: 'POST', keepSessionOn401: true });
}
